import { jsx as t, jsxs as k, Fragment as W } from "react/jsx-runtime";
import { AlertGroup as Zt, Alert as en, AlertVariant as Be, AlertActionCloseButton as tn, Page as nn, Modal as vt, ModalVariant as rn, TextContent as an, Text as ke, Button as q, Spinner as Ct, FormHelperText as Ge, HelperText as We, HelperTextItem as ze, Popover as ln, Icon as Ne, FormGroup as kt, NumberInput as sn, ValidatedOptions as H, InputGroup as xe, InputGroupItem as _e, TextInput as Se, Select as Ee, SelectList as Ae, SelectOption as Je, MenuToggle as me, MenuToggleStatus as Ye, TextInputGroup as It, TextInputGroupMain as wt, ChipGroup as Qe, Chip as Xe, TextInputGroupUtilities as Tt, Switch as on, TextArea as xt, FileUpload as cn, Title as dn, Card as un, CardHeader as hn, CardTitle as pn, CardBody as mn, Grid as fn, GridItem as st, PageSection as gn, JumpLinks as yn, JumpLinksItem as bn, ButtonVariant as we, Checkbox as vn, Radio as Cn, MenuFooter as kn, Dropdown as In, DropdownList as wn, DropdownItem as ot, Masthead as Tn, MastheadToggle as xn, PageToggleButton as Sn, MastheadBrand as En, MastheadContent as An, Toolbar as Ie, ToolbarContent as qe, ToolbarItem as G, Avatar as Rn, Bullseye as Dn, EmptyState as On, EmptyStateIcon as ct, EmptyStateHeader as Fn, EmptyStateBody as Pn, EmptyStateFooter as Vn, EmptyStateActions as Mn, SearchInput as Ln, Divider as Bn, Pagination as Nn, Badge as _n } from "@patternfly/react-core";
import { createContext as St, useContext as Et, useRef as Y, useEffect as se, useCallback as he, useState as A, useMemo as U, forwardRef as qn, useId as At, Fragment as Rt, Children as Dt, Component as $n, isValidElement as Un } from "react";
import { useTranslation as $ } from "react-i18next";
import { NetworkError as Ot } from "@keycloak/keycloak-admin-client";
import Kn from "keycloak-js";
import { ExclamationCircleIcon as Hn, ExclamationTriangleIcon as jn, HelpIcon as Gn, EyeIcon as Wn, EyeSlashIcon as zn, TimesIcon as Ft, CubeIcon as Jn, PaypalIcon as Yn, InstagramIcon as Qn, BitbucketIcon as Xn, MicrosoftIcon as Zn, TwitterIcon as er, StackOverflowIcon as tr, OpenshiftIcon as nr, LinkedinIcon as rr, GoogleIcon as ar, GitlabIcon as lr, FacebookSquareIcon as ir, GithubIcon as sr, MinusCircleIcon as or, PlusCircleIcon as Pt, EllipsisVIcon as cr, BarsIcon as dr, SearchIcon as ur, SyncAltIcon as hr } from "@patternfly/react-icons";
import { useFormContext as Re, Controller as oe, useController as De, FormProvider as pr, useWatch as mr } from "react-hook-form";
import { get as _, cloneDeep as fr, intersectionBy as gr } from "lodash-es";
import ve from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as yr } from "@patternfly/react-styles";
import { Table as br, TableVariant as vr, Thead as Cr, Tr as Ce, Th as Me, Tbody as dt, Td as le, ExpandableRowContent as kr, ActionsColumn as Ir, TableText as wr } from "@patternfly/react-table";
import './main.css';function Ze(e, n) {
  const r = St(n);
  return r.displayName = e, r;
}
const Tr = ["error", "errorMessage"], Le = "error_description";
function xr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ot)
    return Vt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Sr(e) {
  if (!(e instanceof Ot))
    return;
  const n = e.responseData;
  return Er(n);
}
function Er(e) {
  if (typeof e == "object" && e !== null && Le in e && typeof e[Le] == "string")
    return e[Le];
}
function Vt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of Tr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Ar = () => Math.floor(Math.random() * 1e3);
function Rr(e) {
  return e != null;
}
function et(e) {
  const n = Et(e);
  if (Rr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Dr() {
  const e = Y(!1), n = Y(/* @__PURE__ */ new Set());
  se(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, l));
    n.current.add(i);
    function s() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Or({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    Zt,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, s) => /* @__PURE__ */ t(
        en,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Be[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            tn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Fr = 8e3, Mt = Ze(
  "AlertContext",
  void 0
), qa = () => et(Mt), Pr = ({ children: e }) => {
  const { t: n } = $(), r = Dr(), [a, l] = A([]), i = (c) => l((u) => u.filter((d) => d.id !== c)), s = he(
    (c, u = Be.success, d) => {
      const g = {
        id: Ar(),
        message: c,
        variant: u,
        description: d
      };
      l((y) => [g, ...y]), r(() => i(g.id), Fr);
    },
    [r]
  ), o = he(
    (c, u) => {
      const d = n(c, { error: xr(u) }), g = Sr(u);
      s(d, Be.danger, g);
    },
    [s, n]
  ), h = U(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ k(Mt.Provider, { value: h, children: [
    /* @__PURE__ */ t(Or, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Vr = (e) => {
  const { t: n, i18n: r } = $(), a = e.error, l = Mr(a), i = Vt(a);
  console.error(a);
  function s() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(nn, { children: /* @__PURE__ */ t(
    vt,
    {
      variant: rn.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(q, { variant: "primary", onClick: s, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(an, { children: l ? /* @__PURE__ */ t(ke, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(ke, { children: n(i) }) : /* @__PURE__ */ t(ke, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Mr(e) {
  return e instanceof Error ? e.message : null;
}
function Lr(e, n, r) {
  const [a, l] = A(
    () => e.getItem(n) ?? r
  ), i = he((s) => {
    l(s), e.setItem(n, s);
  }, []);
  return se(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, i];
}
function Lt(e, n, r) {
  const a = U(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Lr(
    e,
    n,
    a
  ), s = U(() => JSON.parse(l), [l]), o = he(
    (h) => i(JSON.stringify(h)),
    []
  );
  return [s, o];
}
const Bt = Ze(
  "HelpContext",
  void 0
), Br = () => et(Bt), Nr = ({ children: e }) => {
  const [n, r] = Lt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Bt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, _r = () => St(void 0);
let $e;
const $a = () => {
  const e = Et($e);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, Ua = ({
  environment: e,
  keycloak: n,
  children: r
}) => {
  $e = _r();
  const a = Y(!1), [l, i] = A(!!n), [s, o] = A(), h = U(() => {
    if (n)
      return n;
    const c = new Kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [e, n]);
  return se(() => {
    if (n || a.current)
      return;
    h.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => i(!0)).catch((u) => o(u)), a.current = !0;
  }, [h, n]), s ? /* @__PURE__ */ t(Vr, { error: s }) : l ? /* @__PURE__ */ t($e.Provider, { value: { environment: e, keycloak: h }, children: /* @__PURE__ */ t(Pr, { children: /* @__PURE__ */ t(Nr, { children: r }) }) }) : /* @__PURE__ */ t(Ct, {});
};
function Ka() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ha = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: o,
  component: h = q,
  children: c,
  ...u
}) => {
  const [d, g] = A(!1);
  return /* @__PURE__ */ k(W, { children: [
    /* @__PURE__ */ t(
      h,
      {
        variant: i,
        onClick: () => g(!0),
        isDisabled: l,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      vt,
      {
        variant: "small",
        ...u,
        title: e,
        isOpen: d,
        onClose: () => g(!1),
        actions: [
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                g(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => g(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, Nt = ({ message: e, ...n }) => /* @__PURE__ */ t(Ge, { ...n, children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), _t = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1,
  isRecommendation: l = !1
}) => {
  const { enabled: i } = Br(), s = l ? jn : Gn;
  return i ? /* @__PURE__ */ t(ln, { bodyContent: e, children: /* @__PURE__ */ k(W, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (o) => o.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(
          Ne,
          {
            isInline: r,
            status: l ? "warning" : void 0,
            children: /* @__PURE__ */ t(s, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ t(
      Ne,
      {
        isInline: r,
        status: l ? "warning" : void 0,
        children: /* @__PURE__ */ t(s, {})
      }
    )
  ] }) }) : null;
};
function ce(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Q = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...s
}) => /* @__PURE__ */ k(
  kt,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: a ? /* @__PURE__ */ t(_t, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...s,
    children: [
      i,
      l && /* @__PURE__ */ t(Nt, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), ja = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = Re();
  return /* @__PURE__ */ t(
    Q,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: o }) => {
            const h = !!r.rules?.required, c = ce(r.rules?.min), u = o.value ?? r.defaultValue, d = (g) => o.onChange(
              c !== void 0 ? Math.max(g, Number(c)) : g
            );
            return /* @__PURE__ */ t(
              sn,
              {
                ...l,
                id: e,
                value: u,
                validated: s[e] ? H.error : H.default,
                required: h,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => d(u + 1),
                onMinus: () => d(u - 1),
                onChange: (g) => {
                  const y = Number(g.currentTarget.value);
                  d(isNaN(y) ? r.defaultValue : y);
                }
              }
            );
          }
        }
      )
    }
  );
}, qr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = $(), [l, i] = A(!0);
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ t(_e, { isFill: !0, children: /* @__PURE__ */ t(
      Se,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      q,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(zn, {})
      }
    )
  ] });
}, qt = qn(
  (e, n) => /* @__PURE__ */ t(qr, { ...e, innerRef: n })
);
qt.displayName = "PasswordInput";
const Ga = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: s } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ k(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          qt,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? H.error : H.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(Ge, { children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { children: e.helperText }) }) })
      ]
    }
  );
}, $r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  isDisabled: o,
  isFullWidth: h = !0,
  onSelect: c,
  ...u
}) => {
  const {
    control: d,
    formState: { errors: g }
  } = Re(), [y, C] = A(!1), R = ce(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: R,
      error: _(g, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: d,
          render: ({ field: { onChange: v, value: p } }) => /* @__PURE__ */ t(
            Ee,
            {
              ...u,
              variant: "default",
              onClick: () => C(!y),
              onOpenChange: () => C(!1),
              selected: re(a) ? a.filter(
                (b) => Array.isArray(p) ? p.includes(b.key) : p === b.key
              ).map((b) => b.value) : p,
              toggle: (b) => /* @__PURE__ */ t(
                me,
                {
                  id: e || n,
                  ref: b,
                  onClick: () => C(!y),
                  isExpanded: y,
                  isFullWidth: h,
                  status: _(g, n) ? Ye.danger : void 0,
                  "aria-label": r,
                  isDisabled: o,
                  children: re(a) ? a.find(
                    (E) => E.key === (Array.isArray(p) ? p[0] : p)
                  )?.value : p
                }
              ),
              onSelect: (b, E) => {
                const I = E?.toString(), f = Array.isArray(p) ? [I] : I;
                c ? c(f, v) : v(f), C(!1);
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Ae, { "data-testid": `select-${n}`, children: [...a, ...l].map((b) => /* @__PURE__ */ t(
                Je,
                {
                  value: ie(b),
                  description: !pe(b) && "description" in b ? b.description : void 0,
                  children: pe(b) ? b : b.value
                },
                ie(b)
              )) })
            }
          )
        }
      )
    }
  );
}, ne = (e) => pe(e) ? e : e.value, Ur = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  placeholderText: o,
  onFilter: h,
  variant: c,
  isFullWidth: u = !0,
  ...d
}) => {
  const {
    control: g,
    formState: { errors: y }
  } = Re(), [C, R] = A(!1), [v, p] = A(""), [b, E] = A(0), [I, f] = A([]), T = Y(), V = ce(i.rules?.required) === !0, O = c === ue.typeaheadMulti, D = U(
    () => [
      ...a.filter(
        (m) => !l.map((x) => ne(x)).includes(ne(m))
      ),
      ...l
    ],
    [l, a]
  ), j = D.filter(
    (m) => ne(m).toLowerCase().startsWith(v.toLowerCase())
  ), F = (m, x) => {
    x.value.includes(m) ? (x.onChange(x.value.filter((S) => S !== m)), re(a) && f(
      I.filter((S) => S.key !== m)
    )) : (x.onChange([...x.value, m]), re(D) && f([
      ...I,
      D.find((S) => S.key === m)
    ]));
  }, B = (m, x) => {
    const S = j[b];
    switch (R(!0), m.key) {
      case "Enter": {
        m.preventDefault(), p(O ? "" : ne(S)), F(ie(S), x), R(!1), E(0);
        break;
      }
      case "Tab":
      case "Escape": {
        R(!1), x.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === ue.typeahead && x.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        m.preventDefault();
        let L = 0;
        m.key === "ArrowUp" && (b === 0 ? L = a.length - 1 : L = b - 1), m.key === "ArrowDown" && (b === a.length - 1 ? L = 0 : L = b + 1), E(L);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Q,
    {
      id: e,
      name: n,
      label: r,
      isRequired: V,
      error: _(y, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: g,
          render: ({ field: m }) => /* @__PURE__ */ t(
            Ee,
            {
              ...d,
              onOpenChange: () => R(!1),
              selected: re(D) ? D.filter(
                (x) => Array.isArray(m.value) ? m.value.includes(x.key) : m.value === x.key
              ).map((x) => x.value) : m.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (x) => /* @__PURE__ */ t(
                me,
                {
                  ref: x,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    R(!C), T.current?.focus();
                  },
                  isExpanded: C,
                  isFullWidth: u,
                  status: _(y, n) ? Ye.danger : void 0,
                  children: /* @__PURE__ */ k(It, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      wt,
                      {
                        placeholder: o,
                        value: c === ue.typeahead && m.value ? re(D) ? D.find(
                          (S) => S.key === (Array.isArray(m.value) ? m.value[0] : m.value)
                        )?.value : m.value : v,
                        onClick: () => R(!C),
                        onChange: (S, L) => {
                          p(L), h?.(L);
                        },
                        onKeyDown: (S) => B(S, m),
                        autoComplete: "off",
                        innerRef: T,
                        role: "combobox",
                        isExpanded: C,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === ue.typeaheadMulti && Array.isArray(m.value) && /* @__PURE__ */ t(Qe, { "aria-label": "Current selections", children: m.value.map(
                          (S, L) => /* @__PURE__ */ t(
                            Xe,
                            {
                              onClick: (N) => {
                                N.stopPropagation(), m.onChange(
                                  m.value.filter(
                                    (Z) => Z !== ie(S)
                                  )
                                );
                              },
                              children: re(D) ? [
                                ...D,
                                ...I
                              ].find((N) => S === N.key)?.value : ne(S)
                            },
                            L
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(Tt, { children: (!!v || m.value) && /* @__PURE__ */ t(
                      q,
                      {
                        variant: "plain",
                        onClick: () => {
                          p(""), m.onChange(O ? [] : ""), T?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Ft, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (x, S) => {
                x?.stopPropagation();
                const L = S?.toString();
                O && Array.isArray(m.value) ? (p(""), F(L || "", m)) : (m.onChange(Array.isArray(m.value) ? [L] : L), R(!1));
              },
              isOpen: C,
              children: /* @__PURE__ */ t(Ae, { children: j.map((x, S) => /* @__PURE__ */ t(
                Je,
                {
                  value: ie(x),
                  isFocused: b === S,
                  isActive: m.value.includes(ne(x)),
                  description: !pe(x) && "description" in x ? x.description : void 0,
                  children: ne(x)
                },
                ie(x)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const re = (e) => typeof e[0] != "string", pe = (e) => typeof e == "string", ie = (e) => pe(e) ? e : e.key, Kr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t($r, { ...n }) : /* @__PURE__ */ t(Ur, { ...n, variant: e }), Ue = (e) => e && typeof e == "string" ? e.includes("${") : !1, Ke = (e) => e.substring(2, e.length - 1), ae = (e, n, r, a) => {
  const l = n || r, i = Ue(l) ? Ke(l) : l, s = a ? `${a}.${i}` : i;
  return e(s || "");
}, He = (e, n) => ae(e, n.displayName, n.name), Hr = ["username", "firstName", "lastName", "email"], $t = (e) => e && Hr.includes(e), X = (e) => `${$t(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Wa = (e) => e.replaceAll(".", "🍺"), jr = (e) => e.replaceAll("🍺", ".");
function za(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => Ue(i) ? r(Ke(i)) : i)
    );
    n(X(a.field), {
      message: r(
        Ue(a.errorMessage) ? Ke(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Oe({
  required: e
}) {
  return e;
}
function Ja(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ut(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ut);
}
function ut(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Ya = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Re();
  return /* @__PURE__ */ t(
    Q,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          control: o,
          name: l.name,
          defaultValue: s,
          render: ({ field: { onChange: h, value: c } }) => /* @__PURE__ */ t(
            on,
            {
              ...l,
              id: l.name,
              "data-testid": jr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? c === "true" : c,
              onChange: (u, d) => {
                const g = n ? d.toString() : d;
                l.onChange?.(u, d), h(g);
              }
            }
          )
        }
      )
    }
  );
}, Qa = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = De({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Q,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        xt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? H.error : H.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Xa = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!ce(e.rules?.required), i = e.defaultValue ?? "", { field: s, fieldState: o } = De({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ k(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          Se,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? H.error : H.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(Ge, { children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(ze, { children: r }) }) })
      ]
    }
  );
}, Gr = xt, Za = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { t: i } = $(), [s, o] = A(""), { field: h, fieldState: c } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Q,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: c.error,
      children: /* @__PURE__ */ t(
        cn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: s,
          browseButtonText: i("browse"),
          validated: c.error ? H.error : H.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (u, d) => {
            h.onChange(d), o(d.name);
          },
          onClearClick: () => {
            h.onChange(null), o("");
          },
          ...r,
          ...h
        }
      )
    }
  );
}, el = ({ icon: e }) => {
  const n = Wr(e);
  return /* @__PURE__ */ t(Ne, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function Wr(e) {
  switch (e) {
    case "github":
      return sr;
    case "facebook":
      return ir;
    case "gitlab":
      return lr;
    case "google":
      return ar;
    case "linkedin":
    case "linkedin-openid-connect":
      return rr;
    case "openshift-v4":
      return nr;
    case "stackoverflow":
      return tr;
    case "twitter":
      return er;
    case "microsoft":
      return Zn;
    case "bitbucket":
      return Xn;
    case "instagram":
      return Qn;
    case "paypal":
      return Yn;
    default:
      return Jn;
  }
}
const zr = "_title_180i0_2", Jr = {
  title: zr
}, Ut = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  dn,
  {
    headingLevel: r,
    size: a,
    className: Jr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Yr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = At();
  return /* @__PURE__ */ k(un, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(hn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t(Ut, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__body", children: n })
  ] });
}, Qr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ k(W, { children: [
    /* @__PURE__ */ t(Ut, { id: a, title: n }),
    r
  ] }) });
}, Xr = "_panel_1cdve_1", Zr = "_sticky_1cdve_5", ht = {
  panel: Xr,
  sticky: Zr
}, ea = "kc-main-content-page-container", pt = (e) => e.replace(/\s+/g, "-"), ta = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = U(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ k(fn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(st, { md: 8, sm: 12, children: l.map(({ title: i, panel: s }) => {
      const o = pt(i.toLowerCase());
      return /* @__PURE__ */ t(Rt, { children: r ? /* @__PURE__ */ t(
        Yr,
        {
          scrollId: o,
          title: i,
          className: ht.panel,
          children: s
        }
      ) : /* @__PURE__ */ t(Qr, { scrollId: o, title: i, children: s }) }, i);
    }) }),
    /* @__PURE__ */ t(st, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(gn, { className: ht.sticky, children: /* @__PURE__ */ t(
      yn,
      {
        isVertical: !0,
        scrollableSelector: `#${ea}`,
        label: e,
        offset: 100,
        children: l.map(({ title: i }) => {
          const s = pt(i.toLowerCase());
          return /* @__PURE__ */ t(
            bn,
            {
              onClick: () => {
                const o = document.getElementById(s);
                o && o.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${s}`,
              children: i
            },
            i
          );
        })
      }
    ) }) })
  ] });
}, na = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, tl = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  q,
  {
    variant: "primary",
    isDisabled: e && !na(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), ra = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, aa = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = U(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, ra(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(pr, { ...n, children: /* @__PURE__ */ t(
    Kr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, fe = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = ae(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), h = _(s, X(r.name));
  return /* @__PURE__ */ k(
    kt,
    {
      label: He(e, r) || "",
      fieldId: r.name,
      isRequired: Oe(r),
      labelIcon: i ? /* @__PURE__ */ t(_t, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ k(xe, { children: [
          l,
          o
        ] }) : l,
        h && /* @__PURE__ */ t(
          Nt,
          {
            "data-testid": `${r.name}-helper`,
            message: h.message
          }
        )
      ]
    },
    r.name
  );
}, la = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(fe, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  ia,
  {
    t: e,
    form: n,
    "aria-label": He(e, r),
    name: X(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: He(e, r)
    }),
    ...l
  }
) }), ia = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: s,
  id: o,
  ...h
}) => {
  const { register: c, setValue: u, control: d } = a, g = mr({
    name: n,
    control: d,
    defaultValue: s || ""
  }), y = U(() => Array.isArray(g) && g.length !== 0 ? g : s || [""], [g]), C = (E) => {
    p([...y.slice(0, E), ...y.slice(E + 1)]);
  }, R = () => {
    p([...y, ""]);
  }, v = (E, I) => {
    p([...y.slice(0, E), I, ...y.slice(E + 1)]);
  }, p = (E) => {
    const I = E.flatMap((f) => f);
    u(n, I, {
      shouldDirty: !0
    });
  }, b = r.startsWith("html") ? r.substring(6) : "text";
  return se(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: o, children: y.map((E, I) => /* @__PURE__ */ k(Rt, { children: [
    /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ t(_e, { isFill: !0, children: /* @__PURE__ */ t(
        Se,
        {
          "data-testid": n + I,
          onChange: (f, T) => v(I, T),
          name: `${n}.${I}.value`,
          value: E,
          isDisabled: i,
          type: b,
          ...h
        }
      ) }),
      /* @__PURE__ */ t(_e, { children: /* @__PURE__ */ t(
        q,
        {
          "data-testid": "remove" + I,
          variant: we.link,
          onClick: () => C(I),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: y.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    I === y.length - 1 && /* @__PURE__ */ k(
      q,
      {
        variant: we.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !E || i,
        children: [
          /* @__PURE__ */ t(Pt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, I)) });
}, mt = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Oe(a), i = r.startsWith("multiselect"), s = i ? vn : Cn, o = a.validators?.options?.options || [], h = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: X(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: u }) => /* @__PURE__ */ t(W, { children: o.map((d) => /* @__PURE__ */ t(
        s,
        {
          id: d,
          "data-testid": d,
          label: ae(e.t, h[d], d, c),
          value: d,
          isChecked: u.value?.includes(d),
          onChange: () => {
            i ? u.value?.includes(d) ? u.onChange(
              u.value?.filter((g) => g !== d)
            ) : u.onChange([...u.value || [], d]) : u.onChange([d]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        d
      )) })
    }
  ) });
}, sa = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: s,
  width: o,
  maxHeight: h,
  toggleIcon: c,
  className: u,
  isDisabled: d,
  children: g,
  ...y
}) => {
  const [C, R] = A(!1), v = Y(), p = () => {
    R(!C), n(!C);
  }, b = () => i === "parent" && v.current?.parentElement || "inline", E = Dt.toArray(
    g
  );
  return /* @__PURE__ */ t(
    Ee,
    {
      ref: v,
      maxMenuHeight: Te(h),
      isScrollable: !0,
      popperProps: {
        appendTo: b(),
        direction: s,
        width: Te(o)
      },
      ...y,
      onClick: p,
      onOpenChange: (I) => {
        I !== C && p();
      },
      selected: a,
      onSelect: (I, f) => {
        r?.(f || ""), p();
      },
      toggle: (I) => /* @__PURE__ */ t(
        me,
        {
          id: e,
          ref: I,
          className: u,
          onClick: p,
          isExpanded: l,
          "aria-label": y["aria-label"],
          icon: c,
          isDisabled: d,
          isFullWidth: !0,
          children: E.find((f) => f.props.value === a)?.props.children || a || y["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ae, { children: g })
    }
  );
}, oa = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: s,
  maxHeight: o,
  width: h,
  toggleIcon: c,
  direction: u,
  selections: d,
  typeAheadAriaLabel: g,
  chipGroupComponent: y,
  chipGroupProps: C,
  footer: R,
  isDisabled: v,
  children: p,
  ...b
}) => {
  const [E, I] = A(""), [f, T] = A(0), V = Y(), O = Dt.toArray(
    p
  ), D = () => {
    r?.(!b.isOpen);
  }, j = (F) => {
    const B = O[f];
    switch (r?.(!0), F.key) {
      case "Enter": {
        F.preventDefault(), l !== J.typeaheadMulti ? I(B.props.value) : I(""), n?.(B.props.value), r?.(!1), T(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        l === J.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        F.preventDefault();
        let m = 0;
        F.key === "ArrowUp" && (f === 0 ? m = O.length - 1 : m = f - 1), F.key === "ArrowDown" && (f === O.length - 1 ? m = 0 : m = f + 1), T(m);
        break;
      }
    }
  };
  return /* @__PURE__ */ k(
    Ee,
    {
      ...b,
      onClick: D,
      onOpenChange: (F) => r?.(F),
      onSelect: (F, B) => {
        n?.(B || ""), a?.(""), I("");
      },
      maxMenuHeight: Te(o),
      popperProps: { direction: u, width: Te(h) },
      toggle: (F) => /* @__PURE__ */ t(
        me,
        {
          ref: F,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: c,
          isDisabled: v,
          isExpanded: b.isOpen,
          isFullWidth: !0,
          status: i === "error" ? Ye.danger : void 0,
          children: /* @__PURE__ */ k(It, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              wt,
              {
                placeholder: s,
                value: l === J.typeahead && d ? d : E,
                onClick: D,
                onChange: (B, m) => {
                  I(m), a?.(m);
                },
                onKeyDown: (B) => j(B),
                autoComplete: "off",
                innerRef: V,
                role: "combobox",
                isExpanded: b.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": g,
                children: l === J.typeaheadMulti && Array.isArray(d) && (y || /* @__PURE__ */ t(Qe, { ...C, children: d.map((B, m) => /* @__PURE__ */ t(
                  Xe,
                  {
                    onClick: (x) => {
                      x.stopPropagation(), n?.(B);
                    },
                    children: B
                  },
                  m
                )) }))
              }
            ),
            /* @__PURE__ */ t(Tt, { children: !!E && /* @__PURE__ */ t(
              q,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), I(""), a?.(""), V?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Ft, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ae, { children: p }),
        R && /* @__PURE__ */ t(kn, { children: R })
      ]
    }
  );
};
var J = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(J || {});
const Te = (e) => typeof e == "number" ? e + "px" : e, ca = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(sa, { ...n }) : /* @__PURE__ */ t(oa, { ...n, variant: e }), ft = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, s] = A(!1), [o, h] = A(""), c = a === "multiselect", u = (v, p) => {
    c ? p.value?.includes(v) ? p.onChange(p.value.filter((b) => b !== v)) : Array.isArray(p.value) ? p.onChange([...p.value, v]) : p.onChange([v]) : p.onChange(v === p.value ? "" : v);
  }, d = l.validators?.options?.options || [], g = l.annotations?.inputOptionLabels || {}, y = l.annotations?.inputOptionLabelsI18nPrefix, C = (v) => ae(e.t, g[v], v, y), R = (v) => d.filter(
    (p) => C(p).toLowerCase().includes(o.toLowerCase())
  ).map((p) => /* @__PURE__ */ t(
    Je,
    {
      selected: v === p,
      value: p,
      children: C(p)
    },
    p
  ));
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: X(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: v }) => /* @__PURE__ */ t(
        ca,
        {
          toggleId: l.name,
          onToggle: (p) => s(p),
          onClear: () => u("", v),
          onSelect: (p) => {
            const b = p.toString();
            u(b, v), Array.isArray(v.value) || s(!1);
          },
          selections: c && Array.isArray(v.value) ? v.value.map((p) => C(p)) : C(v.value),
          variant: c ? J.typeaheadMulti : d.length >= 10 ? J.typeahead : J.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (p) => (h(p), R(v.value)),
          children: R(v.value)
        }
      )
    }
  ) });
}, da = (e) => {
  const { form: n, attribute: r } = e, a = Oe(r);
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    Gr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(X(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, K = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Oe(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(fe, { ...e, children: /* @__PURE__ */ t(
    Se,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : ae(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(X(a.name))
    }
  ) });
}, je = {
  text: K,
  textarea: da,
  select: ft,
  "select-radiobuttons": mt,
  multiselect: ft,
  "multiselect-checkboxes": mt,
  "html5-email": K,
  "html5-tel": K,
  "html5-url": K,
  "html5-number": K,
  "html5-range": K,
  "html5-datetime-local": K,
  "html5-date": K,
  "html5-month": K,
  "html5-time": K,
  "multi-input": la
}, nl = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const o = U(() => {
    if (!r.attributes)
      return [];
    const h = i ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: h.filter(
        (u) => u.group === c.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    ta,
    {
      label: e("jumpToSection"),
      sections: o.filter((h) => h.attributes.length > 0).map(({ group: h, attributes: c }) => ({
        title: ae(e, h.displayHeader, h.name) || e("general"),
        panel: /* @__PURE__ */ k("div", { className: "pf-v5-c-form", children: [
          h.displayDescription && /* @__PURE__ */ t(ke, { className: "pf-v5-u-pb-lg", children: ae(e, h.displayDescription, "") }),
          c.map((u) => /* @__PURE__ */ t(
            ua,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: s,
              attribute: u
            },
            u.name
          ))
        ] })
      }))
    }
  );
}, ua = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const s = n.watch(
    X(i.name)
  ), o = U(() => pa(i), [i]), h = i.multivalued || fa(s) && i.annotations?.inputType === void 0 ? je["multi-input"] : je[o];
  return i.name === "locale" ? /* @__PURE__ */ t(
    aa,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    h,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: i,
      renderer: r
    }
  );
}, ha = "text";
function pa(e) {
  if ($t(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return ma(n) ? n : ha;
}
const ma = (e) => typeof e == "string" && e in je, fa = (e) => Array.isArray(e) && e.length > 1, ga = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ k(
  "svg",
  {
    className: yr(
      ve.avatar,
      ve.modifiers[r],
      n === "light" && ve.modifiers.light,
      n === "dark" && ve.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ k("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), gt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = A(!1);
  return /* @__PURE__ */ t(
    In,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ t(
        me,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(cr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(wn, { children: r })
    }
  );
};
function ya(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const rl = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: h = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: u = [],
  toolbarItems: d,
  toolbar: g,
  ...y
}) => {
  const { t: C } = $(), R = [];
  o && R.push(
    /* @__PURE__ */ t(
      ot,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), s && R.push(
    /* @__PURE__ */ t(ot, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const v = e.idTokenParsed?.picture;
  return /* @__PURE__ */ k(Tn, { ...y, children: [
    /* @__PURE__ */ t(xn, { children: /* @__PURE__ */ t(Sn, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(dr, {}) }) }),
    /* @__PURE__ */ t(En, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ k(An, { children: [
      g,
      /* @__PURE__ */ t(Ie, { children: /* @__PURE__ */ k(qe, { children: [
        d?.map((p, b) => /* @__PURE__ */ t(G, { align: { default: "alignRight" }, children: p }, b)),
        /* @__PURE__ */ t(
          G,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              gt,
              {
                "data-testid": "options",
                dropDownItems: [...u, R],
                title: h ? ya(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              gt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || u,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: v || i?.src ? /* @__PURE__ */ t(Rn, { src: v, alt: C("avatar"), ...i }) : /* @__PURE__ */ t(ga, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Kt = Ze("ErrorBoundaryContext", void 0), Ht = () => et(Kt);
class al extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Kt.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const ll = ({ children: e, fallback: n }) => {
  const { error: r } = Ht();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ba(e, n, r) {
  const { showBoundary: a } = Ht();
  se(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((s) => {
      i.aborted || n(s);
    }).catch((s) => {
      console.error(s), i.aborted || a(s);
    }), () => l.abort();
  }, r);
}
const va = () => {
  const { t: e } = $();
  return /* @__PURE__ */ t(Dn, { children: /* @__PURE__ */ t(Ct, { "aria-label": e("spinnerLoading") }) });
}, Ca = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: s,
  icon: o,
  isDisabled: h = !1,
  children: c
}) => /* @__PURE__ */ k(On, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: ur }) : a && /* @__PURE__ */ t(ct, { icon: o || Pt }),
  /* @__PURE__ */ t(Fn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Pn, { children: n }),
  /* @__PURE__ */ k(Vn, { children: [
    i && /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: h,
        children: i
      }
    ),
    c,
    s && /* @__PURE__ */ t(Mn, { children: s.map((u) => /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${u.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: u.type || we.secondary,
        onClick: u.onClick,
        isDisabled: h,
        children: u.text
      },
      u.text
    )) })
  ] })
] }), ka = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: h } = $(), [c, u] = A(""), d = (y) => {
    u(y.trim()), o?.(y.trim());
  }, g = (y) => {
    y.key === "Enter" && d(c);
  };
  return /* @__PURE__ */ k(W, { children: [
    /* @__PURE__ */ t(Ie, { "data-testid": "table-toolbar", children: /* @__PURE__ */ k(qe, { children: [
      i && /* @__PURE__ */ t(G, { children: /* @__PURE__ */ k(xe, { "data-testid": i, children: [
        l,
        s && /* @__PURE__ */ t(
          Ln,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": h("search"),
            value: c,
            onChange: (y, C) => {
              u(C);
            },
            onSearch: () => d(c),
            onKeyDown: g,
            onClear: () => d("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(Ie, { children: /* @__PURE__ */ t(qe, { children: n }) }),
    /* @__PURE__ */ t(Bn, {}),
    a,
    /* @__PURE__ */ t(Ie, { children: r })
  ] });
}, yt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: h } = $(), c = Math.round(a / l);
  return /* @__PURE__ */ t(
    Nn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${h("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: u,
        lastIndex: d
      }) => /* @__PURE__ */ k("b", { children: [
        u,
        " - ",
        d
      ] }),
      itemCount: r + c * l,
      page: c + 1,
      perPage: l,
      onNextClick: (u, d) => i((d - 1) * l),
      onPreviousClick: (u, d) => s((d - 1) * l),
      onPerPageSelect: (u, d, g) => o(g - 1, d),
      variant: n
    }
  );
}, Ia = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...h
}) => /* @__PURE__ */ t(
  ka,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ k(W, { children: [
      r,
      /* @__PURE__ */ t(G, { variant: "pagination", children: /* @__PURE__ */ t(yt, { count: e, ...h }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(G, { variant: "pagination", children: /* @__PURE__ */ t(yt, { count: e, variant: "bottom", ...h }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, bt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ k(W, { children: [
    e.cells.map((i, s) => /* @__PURE__ */ t(le, { children: jt(i) ? i.title : i }, `cell-${s}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(le, { isActionCell: !0, children: /* @__PURE__ */ t(Ir, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, wa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function Ta({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: s,
  onCollapse: o,
  canSelectAll: h,
  canSelect: c,
  isNotCompact: u,
  isRadio: d,
  ...g
}) {
  const { t: y } = $(), [C, R] = A(i || []), [v, p] = A([]), b = U(
    () => gr(
      C,
      n.map((f) => f.data),
      "id"
    ),
    [C, n]
  );
  se(() => {
    if (h) {
      const f = document.getElementsByName("check-all").item(0);
      if (f) {
        const T = f;
        T.indeterminate = b.length < n.length && b.length > 0;
      }
    }
  }, [C, h, n]);
  const E = (f) => {
    R(f), s?.(f);
  }, I = (f, T) => {
    if (d) {
      const V = T ? [n[f].data] : [];
      E(V);
    } else if (f === -1) {
      const V = b.map(
        (O) => _(O, "id")
      );
      E(
        T ? [...C, ...n.map((O) => O.data)] : C.filter(
          (O) => !V.includes(_(O, "id"))
        )
      );
    } else
      E(T ? [...C, n[f].data] : C.filter(
        (V) => _(V, "id") !== n[f].data.id
      ));
  };
  return /* @__PURE__ */ k(
    br,
    {
      ...g,
      variant: u ? void 0 : vr.compact,
      "aria-label": y(l),
      children: [
        /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ k(Ce, { children: [
          o && /* @__PURE__ */ t(Me, { screenReaderText: y("expandRow") }),
          h && /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: y("selectAll"),
              select: d ? void 0 : {
                onSelect: (f, T) => {
                  I(-1, T);
                },
                isSelected: b.length === n.length
              }
            }
          ),
          e.map((f) => /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: y("expandRow"),
              className: f.transforms?.[0]().className,
              children: y(f.displayKey || f.name)
            },
            f.displayKey || f.name
          ))
        ] }) }),
        o ? n.map((f, T) => /* @__PURE__ */ t(dt, { children: T % 2 === 0 ? /* @__PURE__ */ k(Ce, { children: [
          /* @__PURE__ */ t(
            le,
            {
              expand: n[T + 1].cells.length === 0 ? void 0 : {
                isExpanded: v[T] ?? !1,
                rowIndex: T,
                expandId: "expandable-row-",
                onToggle: (V, O, D) => {
                  o(D, O);
                  const j = [...v];
                  j[T] = D, p(j);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            bt,
            {
              row: f,
              index: T,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ k(Ce, { isExpanded: v[T - 1] ?? !1, children: [
          /* @__PURE__ */ t(le, {}),
          /* @__PURE__ */ t(le, { colSpan: e.length, children: /* @__PURE__ */ t(kr, { children: /* @__PURE__ */ t(wa, { row: f }) }) })
        ] }) }, T)) : /* @__PURE__ */ t(dt, { children: n.map((f, T) => /* @__PURE__ */ k(Ce, { isExpanded: v[T], children: [
          c && /* @__PURE__ */ t(
            le,
            {
              select: {
                rowIndex: T,
                onSelect: (V, O, D) => {
                  I(D, O);
                },
                isSelected: !!C.find(
                  (V) => _(V, "id") === f.data.id
                ),
                variant: d ? "radio" : "checkbox",
                isDisabled: f.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            bt,
            {
              row: f,
              index: T,
              actions: r,
              actionResolver: a
            }
          )
        ] }, T)) })
      ]
    }
  );
}
function xa({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: h,
  loader: c,
  columns: u,
  actions: d,
  actionResolver: g,
  searchTypeComponent: y,
  toolbarItem: C,
  subToolbar: R,
  emptyState: v,
  icon: p,
  isSearching: b = !1,
  ...E
}) {
  const { t: I } = $(), [f, T] = A([]), [V, O] = A(), [D, j] = A(), [F, B] = A(!1), [m, x] = Lt(
    localStorage,
    "pageSize",
    10
  ), [S, L] = A(m), [N, Z] = A(0), [z, Fe] = A(""), tt = Y(), [ge, Gt] = A(0), nt = Y(), rt = () => Gt(ge + 1), Wt = At(), at = (w, P) => w.map((M) => {
    if ("cellFormatters" in M) {
      const te = _(P, M.name);
      return M.cellFormatters?.reduce((de, be) => be(de), te);
    }
    if (M.cellRenderer) {
      const te = M.cellRenderer;
      return { title: /* @__PURE__ */ t(te, { ...P }) };
    }
    return _(P, M.name);
  }), lt = (w) => {
    const P = (M) => o?.[0]?.enabled?.(M);
    return w.map((M, te) => {
      const de = h ? h(M) : !1, be = [
        {
          data: M,
          disableSelection: de,
          disableActions: de,
          selected: !!f.find((Xt) => _(Xt, "id") === _(M, "id")),
          isOpen: P(M) ? !1 : void 0,
          cells: at(u, M)
        }
      ];
      return o && be.push({
        parent: te * 2,
        cells: P(M) ? at(o, M) : []
      }), be;
    }).flat();
  }, Pe = (w) => ["string", "number"].includes(typeof w) ? w.toString() : w instanceof Array ? w.map(Pe).join("") : typeof w == "object" ? Pe(
    Un(w.title) ? w.title.props : Object.values(w)
  ) : "", it = U(
    () => z === "" || r ? void 0 : lt(D || []).filter(
      (w) => w.cells.some(
        (P) => P && Pe(P).toLowerCase().includes(z.toLowerCase())
      )
    ).slice(N, N + S + 1),
    [z, N, S]
  );
  ba(
    async () => {
      B(!0);
      const w = tt.current === "" && z !== "";
      return w && Z(0), tt.current = z, typeof c == "function" ? ge === nt.current && D ? D : await c(w ? 0 : N, S + 1, z) : c;
    },
    (w) => {
      nt.current = ge, r || (j(w), w.length > N ? w = w.slice(N, N + S + 1) : Z(0));
      const P = lt(w);
      O(P), B(!1);
    },
    [
      ge,
      N,
      S,
      z,
      typeof c != "function" ? c : void 0
    ]
  );
  const zt = () => d && fr(d).map((w, P) => (delete w.onRowClick, w.onClick = async (M, te) => {
    await d[P].onRowClick(
      (it || V)[te].data
    ) && (r || Fe(""), rt());
  }, w)), Jt = (w, P) => {
    ee[P].isOpen = w, O([...ee]);
  }, ee = it || V, ye = !ee || ee.length === 0, Ve = z !== "" || b, Yt = o ? S * 2 : S, Qt = o ? (ee?.length || 0) / 2 : ee?.length || 0;
  return /* @__PURE__ */ k(W, { children: [
    (!ye || Ve) && /* @__PURE__ */ k(
      Ia,
      {
        id: Wt,
        count: Qt,
        first: N,
        max: S,
        onNextClick: Z,
        onPreviousClick: Z,
        onPerPageSelect: (w, P) => {
          Z(w), L(P), x(P);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Fe,
        inputGroupPlaceholder: I(n || ""),
        searchTypeComponent: y,
        toolbarItem: /* @__PURE__ */ k(W, { children: [
          C,
          " ",
          /* @__PURE__ */ t(G, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(G, { children: /* @__PURE__ */ k(q, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(hr, {}),
            " ",
            I("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !F && !ye && /* @__PURE__ */ t(
            Ta,
            {
              ...E,
              canSelectAll: l,
              canSelect: !!a,
              selected: f,
              onSelect: (w) => {
                T(w), a?.(w);
              },
              onCollapse: o ? Jt : void 0,
              actions: zt(),
              actionResolver: g,
              rows: ee.slice(0, Yt),
              columns: u,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !F && ye && Ve && /* @__PURE__ */ t(
            Ca,
            {
              hasIcon: !0,
              icon: p,
              isSearchVariant: !0,
              message: I("noSearchResults"),
              instructions: I("noSearchResultsInstructions"),
              secondaryActions: b ? [] : [
                {
                  text: I("clearAllFilters"),
                  onClick: () => Fe(""),
                  type: we.link
                }
              ]
            }
          )
        ]
      }
    ),
    F && /* @__PURE__ */ t(va, {}),
    !F && ye && !Ve && v
  ] });
}
const Sa = ({ link: e, organization: n }) => {
  const { t: r } = $();
  return /* @__PURE__ */ t(wr, { wrapModifier: "truncate", children: /* @__PURE__ */ k(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      _n,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Ea = (e) => {
  const { t: n } = $();
  return /* @__PURE__ */ t(
    Qe,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Xe, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, il = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: s,
  deleteLabel: o = "delete",
  link: h,
  children: c,
  actions: u
}) => {
  const { t: d } = $();
  return /* @__PURE__ */ t(
    xa,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: [
        ...s ? [{ title: d(o), onRowClick: s }] : [],
        ...u ?? []
      ],
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (g) => /* @__PURE__ */ t(Sa, { link: h, organization: g })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Ea
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: c
    }
  );
};
export {
  Pr as AlertProvider,
  Ha as ContinueCancelModal,
  ll as ErrorBoundaryFallback,
  al as ErrorBoundaryProvider,
  Vr as ErrorPage,
  Za as FileUploadControl,
  Nt as FormErrorText,
  Yr as FormPanel,
  tl as FormSubmitButton,
  Nr as Help,
  _t as HelpItem,
  el as IconMapper,
  xa as KeycloakDataTable,
  rl as KeycloakMasthead,
  Ua as KeycloakProvider,
  ca as KeycloakSelect,
  va as KeycloakSpinner,
  Gr as KeycloakTextArea,
  Ca as ListEmptyState,
  ja as NumberControl,
  il as OrganizationTable,
  Ia as PaginatingTableToolbar,
  Ga as PasswordControl,
  qt as PasswordInput,
  ta as ScrollForm,
  Kr as SelectControl,
  ue as SelectVariant,
  Ya as SwitchControl,
  ka as TableToolbar,
  Qa as TextAreaControl,
  Xa as TextControl,
  nl as UserProfileFields,
  Wa as beerify,
  Ze as createNamedContext,
  jr as debeerify,
  Ar as generateId,
  Sr as getErrorDescription,
  xr as getErrorMessage,
  Ka as getInjectedEnvironment,
  Er as getNetworkErrorDescription,
  Vt as getNetworkErrorMessage,
  Rr as isDefined,
  Ja as isUserProfileError,
  ae as label,
  ea as mainPageContentId,
  za as setUserProfileServerError,
  qa as useAlerts,
  $a as useEnvironment,
  Ht as useErrorBoundary,
  ba as useFetch,
  Br as useHelp,
  et as useRequiredContext,
  Dr as useSetTimeout,
  Lt as useStoredState
};
//# sourceMappingURL=keycloak-ui-shared.js.map
